/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Steps_AsideInputs */

const en_portal_steps_aside = /** @type {(inputs: Portal_Steps_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three steps, none of them longer than a minute.`)
};

const pl_portal_steps_aside = /** @type {(inputs: Portal_Steps_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trzy kroki, żaden dłuższy niż minuta.`)
};

/**
* | output |
* | --- |
* | "Three steps, none of them longer than a minute." |
*
* @param {Portal_Steps_AsideInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_steps_aside = /** @type {((inputs?: Portal_Steps_AsideInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Steps_AsideInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_steps_aside(inputs)
	return en_portal_steps_aside(inputs)
});